import React from 'react'

import { ShowIf } from '@ztechapps/webui.util'
import { useTrackEvent } from '@ztechapps/webui.telemetry'

import { NotificationWidget } from '../../components/Header/header-widget'
import { useGotoCart } from '../../hooks/useGotoCart'
import { useOrderCartCount } from '../../hooks/useOrderCartCount'
import { useUser } from '../../hooks/useUser'

export const CartWidget = () => {
  const trackEvent = useTrackEvent()
  const { count } = useOrderCartCount()
  const { loggedIn } = useUser()
  const [gotoCart] = useGotoCart()

  return (
    <ShowIf condition={loggedIn}>
      <NotificationWidget
        count={count}
        icon="shopping-cart"
        href={'#'}
        onClick={async (e) => {
          e.preventDefault()
          trackEvent('Cart Button')
          await gotoCart()
        }}
      />
    </ShowIf>
  )
}
